<template>
  <section>
    <p :class="$style.txtcenter">{{ accountEmail }}</p>
    <p :class="[$style.txtcenter, $style.f16]">{{ getTermsType }}</p>
    <a-result status="success">
      <template v-slot:title>
        {{ $t("done_title", { type: isBroker ? "合伙人" : "OTC" }) }}
      </template>
      <template v-slot:subTitle>
        <p v-for="(item, index) in $t('done_subtitle')" :key="index">
          <template v-if="item.includes('{email}')">
            <a :href="`mailto:${customerSupport}`" :class="$style.primary">
              {{ customerSupport }}
            </a>
          </template>
          <template v-else>
            {{ item }}
          </template>
        </p>
      </template>
      <template v-slot:extra>
        <a-divider />
        <div :class="$style.descript">
          <p>{{ $t("done_message[0]") }}</p>

          <i18n path="done_message[1]" tag="p">
            <span :class="$style.tips">{{ $t("done_junk") }}</span>
          </i18n>

          <i18n path="done_message[2]" tag="p">
            <a :href="`mailto:${customerSupport}`" :class="$style.email">
              {{ customerSupport }}
            </a>
          </i18n>
        </div>
        <a-button class="finish_btn" block @click="submitNew">
          {{ $t("Submit a new application") }}
        </a-button>
      </template>
    </a-result>
  </section>
</template>

<script>
import { pick } from "lodash-es";
import { mapState } from "vuex";
import {
  Card,
  Form,
  Button,
  Icon,
  Input,
  Row,
  Col,
  Result,
  Divider
} from "ant-design-vue";
import { getAccountCustomSupport } from "@/api/kyc";
import { displayErrors } from "@/utils";

export default {
  name: "ApplyDone",
  data() {
    return {
      customerSupport: ""
    };
  },
  props: {
    isBroker: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("KYC", ["applyType", "accountEmail"]),
    getTermsType() {
      return this.applyType == 0
        ? this.$t("Terms Type[0]")
        : this.$t("Terms Type[1]");
    }
  },
  components: {
    [Card.name]: Card,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Input.name]: Input,
    [Form.name]: Form,
    [Row.name]: Row,
    [Col.name]: Col,
    [Result.name]: Result,
    [Divider.name]: Divider
  },
  methods: {
    async fetchData() {
      try {
        const data = await getAccountCustomSupport();
        this.customerSupport = data.cs;
      } catch (err) {
        displayErrors(err);
      }
    },
    submitNew() {
      const resolved = this.$router.resolve({
        name: "kyc",
        params: this.$route.params,
        query: pick(this.$route.query, ["role", "remote"])
      });
      window.location.href = resolved.href;
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style module lang="scss">
.txtcenter {
  text-align: center;
}
.f16 {
  font-size: 1.5rem;
}
.primary {
  color: $legend-theme-color;
}
.descript {
  max-width: 40rem;
  text-align: left;
  margin: 0 auto;
  font-weight: 500;
  color: $legend-dark-color;
  .tips {
    color: $legend-dark-color;
    font-weight: 600;
  }
  .email {
    color: $legend-dark-color;
    display: block;
    font-size: 18px;
    font-weight: 600;
    margin: 0.5rem 0;
  }
}
.new {
  margin: 2rem 0 0;
}
</style>
